import { Modal } from '@mantine/core';
// import FileUpload from 'pages/profile/components/fileUpload';

import { Controller, useForm } from 'react-hook-form';

import Useaddnewemployeeblog from '../hooks/useAddnewemployeeblog';
import useUpdateemployeeblog from '../hooks/useUpdateemployeeblog';
import { Dropzone, MIME_TYPES } from '@mantine/dropzone';
import { useState } from 'react';
import { ReactComponent as AddThumbnail } from 'assets/icons/PlusAddIcon.svg';

const ThumbnailEmployeeModal = ({
  moveToNextPage,
  setMoveToNextPage,
  lastData,
  defaultValues,
  setNewStoryModal,
  BlogId,
  thumbnailImage,
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
    reset,
    setValue,
  } = useForm({ mode: 'onChange' });

  const [fileCheck, setFileCheck] = useState(false);
  const [errormsg, setErrormsg] = useState(false);
  const [isDesabled, setIsDesabled] = useState(true);

  const closeFirstModal = () => {
    setNewStoryModal(false);
    setIsDesabled(true);
    reset({ ...defaultValues, thumbnail: '' });
    setMoveToNextPage(false);
  };

  //  Add new blog mutation
  const addNewBlogMutation = Useaddnewemployeeblog(closeFirstModal);
  const updateBlog = useUpdateemployeeblog(closeFirstModal);

  const submitblog = (data) => {
    if (!BlogId) {
      const formDate = new FormData();

      formDate.append('topic', lastData?.topic);
      formDate.append('title', lastData?.title);
      formDate.append('content', lastData?.content);
      formDate.append('minutes', lastData?.minutes);
      formDate.append('is_draft', 'False');
      formDate.append('is_deleted', 'False');
      formDate.append('is_published', 'False');

      formDate.append('thumbnail', watch('thumbnail'));
      addNewBlogMutation.mutate(formDate);
    } else {
      const formDate = new FormData();

      formDate.append('topic', lastData?.topic);
      formDate.append('title', lastData?.title);
      formDate.append('content', lastData?.content);
      formDate.append('minutes', lastData?.minutes);
      formDate.append('is_draft', 'False');
      formDate.append('is_deleted', 'False');
      formDate.append('is_published', 'False');

      if (watch('thumbnail') !== undefined) {
        formDate.append('thumbnail', watch('thumbnail'));
      }

      formDate.append('id', BlogId);
      updateBlog.mutate(formDate);
    }
  };

  return (
    <div>
      <Modal
        opened={moveToNextPage}
        onClose={() => {
          setMoveToNextPage(false);
        }}
        title='Choose or upload a thumbnail photo'
        size={'60%'}
        centered
        overlayColor={'#F8F7F799'}
        overlayBlur={20}
        overlayOpacity={0.5}
        transitionDuration={100}
        overflow='inside'
        className='px-10'
        classNames={{
          title: 'text-lg font-semibold mx-auto',
          body: 'scroller h-full',
        }}
      >
        <div className='flex flex-col justify-center items-center mx-5'>
          <p className='text-center text-[#9B9B9B] mt-5'>
            Choosing an attractive thumbnail will increase the chances of people
            reading your story
          </p>
          <form className='w-full' onSubmit={handleSubmit(submitblog)}>
            <div className='mt-4 w-full'>
              <Controller
                control={control}
                name='thumbnail'
                render={({ field }) => (
                  <Dropzone
                    // loading
                    {...field}
                    // disabled={!turnEditOn}

                    // onReject={(files) => console.log('rejected files', files)}
                    accept={[MIME_TYPES.png, MIME_TYPES.jpeg]}
                    maxSize={'5000000'}
                    onDrop={(files) => {
                      setValue('thumbnail', files[0]);
                      setFileCheck(false);
                      setErrormsg(false);
                      setIsDesabled(false);
                    }}
                    onReject={(files) => {
                      setIsDesabled(true);
                      setValue('file_error', files[0].errors[0].message);

                      if (
                        files[0].errors[0].message ===
                        'File is larger than 5000000 bytes'
                      ) {
                        setErrormsg(true);
                        setFileCheck(false);
                      }
                      if (
                        files[0].errors[0].message ===
                        'File type must be one of image/png, image/jpeg'
                      ) {
                        setFileCheck(true);
                        setErrormsg(false);
                      }
                    }}
                    className={
                      'border-primary rounded-md h-52 flex items-center justify-center bg-[#F8EFEF]'
                    }
                  >
                    {() => (
                      <div className='flex flex-col items-center'>
                        {watch('thumbnail')?.name ? (
                          <div className='w-60 h-28 flex items-center justify-center'>
                            <img
                              src={URL.createObjectURL(watch('thumbnail'))}
                              alt=''
                              className='object-contain w-60 h-28'
                            />
                          </div>
                        ) : thumbnailImage ? (
                          <div className='w-60 h-28 flex items-center justify-center'>
                            <img
                              src={thumbnailImage}
                              alt=''
                              className='object-contain w-60 h-28'
                            />
                          </div>
                        ) : (
                          <>
                            <AddThumbnail />
                            <p className='mt-4 text-gray'>Upload a Thumbnail</p>
                          </>
                        )}
                        {fileCheck ? (
                          <h1 className='text-red-600'>
                            File type must be *jpg or *png
                          </h1>
                        ) : null}

                        {errormsg ? (
                          <h1 className='text-red-600'>
                            File must be less than 5 MB
                          </h1>
                        ) : null}
                      </div>
                    )}
                  </Dropzone>
                )}
              />
              {errors.thumbnail && (
                <p className='text-sm  text-[#fc0101]'>
                  {errors.thumbnail.message}
                </p>
              )}
            </div>
            <button
              disabled={isDesabled}
              className={`w-full mt-2  flex justify-center  `}
            >
              <p
                className={`w-32 ${
                  isDesabled
                    ? 'bg-red-300 cursor-not-allowed'
                    : 'bg-primary hover:bg-[#e4643a]  cursor-pointer'
                } text-white rounded-md py-2 px-4 font-medium flex items-center justify-center `}
              >
                Submit
              </p>
            </button>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default ThumbnailEmployeeModal;
